/*
 * As titled, this function will take a new variable,
 * and will update an item in the array if it exists.
 *
 * array: Target array to either replace or append to
 * itemKey: Key to compare the targetValue against
 * targetValue: Value to compare against each array elements itemKey
 * valueName: Key to update the value of if object exists
 * newValue: New value to update object[valueName] with
 */
export const updateObjectValueInArrayIfItExists = ({
  array,
  itemKey,
  targetValue,
  valueName,
  newValue,
}) => {
  const index = array.findIndex(obj => obj[itemKey] === targetValue)

  if (index === -1) {
    return array
  }
  const newArray = [...array]

  newArray[index][valueName] = newValue

  return newArray
}
